import { Page } from "components/page/page.component";
import { RoomReservationCard } from "components/roomReservationCard/roomReservationCard.component";
import { View } from "components/view/view.component";
import { Text } from 'components/text/text.component'
import { useEffect, useState } from "react";
import style from './dashboard.module.css'
import { PieCard } from "components/pieCard/pieCard.component";
import { useGetRoomOccupationCountApi, useGetRoomReservationDashboardDataApi, useListSantanderDashboardRoomsApi } from "api/dashboard.api";
import { toMonthYearString } from "utils/date.util";
import { Filters } from "components/filters/filters.component";
import { FilterType } from "model/filter.model";
import { ListSantanderDashboardRooms } from "model/dashboard/listSantanderDashboardRooms.model";
import { DashboardDataType } from "data/dashboardDataType.data";
import { ColorRange } from "model/colorRange.model";
import { DashboardType } from "data/dashboardType.data";
import { getSantanderRoomColor } from "utils/color.util";

interface DashboardPageProps {
    companyId?: string,
    dashboardType?: string,
}

export function DashboardPage({companyId, dashboardType}: DashboardPageProps){

    const [buildingIds, setBuildingIds] = useState<string[]>([]);
    const [areaIds, setAreaIds] = useState<string[]>([]);
    const [selectedRoomIds, setSelectedRoomIds] = useState<string[]>([]);
    const [occupationStatus, setOccupationStatus] = useState<'ocupado' | 'desocupado' | undefined>(undefined);

    const {get: getRooms, data: roomsData, loading: loadingRoomsData} = useListSantanderDashboardRoomsApi()

    const _roomsData = dashboardType === DashboardType.restaurantes.id
    ? roomsData?.filter(_ => _.type === DashboardDataType.pieCard)
    : roomsData?.filter(_ => _.type === DashboardDataType.reservationAndOccupationCard)

    const _roomsByBuildingAndArea:{buildingId: string, areaId: string, roomsData: ListSantanderDashboardRooms[]}[] = []
    _roomsData?.forEach(roomData => {
        const buildingId = roomData.room.building?.id ?? 'unknown';
        const areaId = roomData.room.area?.id ?? 'unknown';
        const _roomByBuildingAndArea = _roomsByBuildingAndArea.find(_ => _.buildingId === buildingId && _.areaId === areaId)
        if(_roomByBuildingAndArea){
            _roomByBuildingAndArea.roomsData.push(roomData)
        } else {
            _roomsByBuildingAndArea.push({buildingId, areaId, roomsData: [roomData]})
        }
    })

    

    function _getRooms(){
        getRooms({
            companyUsername: companyId || '',
            buildingIds: buildingIds.length > 0 ? buildingIds : undefined,
            areaIds: areaIds.length > 0 ? areaIds : undefined,
            roomIds: selectedRoomIds.length > 0 ? selectedRoomIds : undefined
        })
    }

    useEffect(()=>{
        _getRooms()
    // eslint-disable-next-line
    }, [buildingIds, areaIds, selectedRoomIds, companyId])

    function handleFilterChange(filter: FilterType){
        if(filter.buildings && filter.buildings.length > 0){
            setBuildingIds(filter.buildings.map(b => b.id))
        } else {
            setBuildingIds([])
        }
        if(filter.areas && filter.areas.length > 0){
            setAreaIds(filter.areas.map(a => a.id))
        } else {
            setAreaIds([])
        }

        setSelectedRoomIds(filter.rooms?.map(r => r.id) || []);
        // _getRooms()
        setOccupationStatus(filter.occupationStatus);
    }

    return <Page menu header title="Dashboard">
        <View className={style.PageContent}>
            {/* <Filters
                showBuildings
                showAreas
                showRooms
                // showOccupationStatus={dashboardType === DashboardType.salasReuniao.id}
                roomIndicatorIds={dashboardType === DashboardType.restaurantes.id ? ['room-occupation-count'] : ['reserva-sala', 'room-occupation-status']}
                companyId={companyId}
                onChange={handleFilterChange}
            /> */}
        {
            loadingRoomsData
            ?
            <View className={style.Indicators}>
                <PieCard loading/> 
                <PieCard loading/> 
                <PieCard loading/> 
                <PieCard loading/>
                <PieCard loading/>
                <PieCard loading/>
            </View>
            :
            !_roomsByBuildingAndArea || _roomsByBuildingAndArea.length <= 0 
            ?<View className={style.IndicatorsContent}>
                {dashboardType === DashboardType.restaurantes.id 
                ? <Text>nenhum restaurante encontrado</Text>
                : <Text>nenhuma sala encontrada</Text> }
            {/* <RoomReservationItem roomId={'teste'} roomName={'Sala'} />  */}
            </View>
            :<View className={style.IndicatorsContent}>
                {_roomsByBuildingAndArea.map(({buildingId, areaId, roomsData}) => (
                    <View key={`${buildingId}-${areaId}`} className={style.IndicatorByBuildingAndAreaContent}>
                        <Text className={style.IndicatorTitle} type='h3' style={{marginBottom:'1rem'}}>{`${roomsData[0].room.building?.name} - ${roomsData[0].room.area?.name}`}</Text>
                        <View className={style.RoomList}>
                            {roomsData.map(roomData => {
                                if(roomData.type === DashboardDataType.pieCard && dashboardType === DashboardType.restaurantes.id) return <RestaurantOccupationItem key={roomData.room.id} restaurantId={roomData.room.id} restaurantName={roomData.room.name} />
                                if(roomData.type === DashboardDataType.reservationAndOccupationCard && dashboardType === DashboardType.salasReuniao.id)return <RoomReservationItem key={roomData.room.id} roomId={roomData.room.id} roomName={roomData.room.name} showOnlyIfOccupied={occupationStatus === 'ocupado'} showOnlyIfNotOccupied={occupationStatus === 'desocupado'} />
                                return <></>
                        })}
                        </View>
                    </View>
                ))}
            </View>
        }
        </View>
    </Page>
}

type RoomReservationItemProps = {
    roomId: string,
    roomName: string,
    showOnlyIfOccupied?: boolean,
    showOnlyIfNotOccupied?: boolean
}

function RoomReservationItem({roomId, roomName, showOnlyIfOccupied, showOnlyIfNotOccupied}: RoomReservationItemProps){
    const {get, data} = useGetRoomReservationDashboardDataApi(roomId)

    // console.log(data)
    
    useEffect(()=>{

        function getData() {
            get()
        }

        getData()

        const interval = setInterval(getData, 60000)

        return () => clearInterval(interval)
    // eslint-disable-next-line
    },[])

    if(showOnlyIfOccupied && !data?.occupied) return <></>
    if(showOnlyIfNotOccupied && (data?.occupied === true || data?.occupied === undefined)) return <></>
    return <RoomReservationCard 
        color={getSantanderRoomColor(data?.reserved, data?.occupied, data?.reserveStartAt)} 
        title={roomName}
        reserved={data?.reserved}
        occupied={data?.occupied}
        reservedBy={data?.reservedBy}
        reserveStartAt={data?.reserveStartAt}
        reserveEndAt={data?.reserveEndAt}
        id={roomId}
    />
}

type RestaurantOccupationItemProps = {
    restaurantId: string,
    restaurantName: string
}
function RestaurantOccupationItem({restaurantId, restaurantName}: RestaurantOccupationItemProps){
    // const {get, data} = useGetRestaurantOccupationDashboardDataApi(restaurantId)
    const {get, data} = useGetRoomOccupationCountApi()

    useEffect(()=>{
        get(restaurantId).catch(e => console.error(`Error fetching restaurant occupation data: ${e.message}`))
        const interval = setInterval(() => get(restaurantId), 60000)
        return () => clearInterval(interval)
    // eslint-disable-next-line
    },[restaurantId])

    function indentifyColor(colorRanges?: ColorRange[], value?: number){
        if (!colorRanges || value === undefined) return undefined
    
        for (const range of colorRanges) {
            const minCheck = range.min === null || value >= range.min
            const maxCheck = range.max === null || value <= range.max
            if (minCheck && maxCheck) {
                return range.color
            }
        }
    
        return undefined
    }

    const pendingRecords = Array.from(new Set(data?.pending?.map(p => `${p.indicator.name}${p.date ? ` - ${toMonthYearString(p.date)}` : ''}`)))
    const alerts = Array.from(new Set(data?.alerts?.map(a => a.message)))

    return <PieCard
        key={restaurantId} 
        value={data?.value} 
        color={indentifyColor(data?.indicator.colorRanges,data?.value)} 
        max={ data?.indicator.unit === '%' ? 100 :  data?.value} 
        unit={data?.indicator.unit} 
        title={`Ocupação - ${restaurantName}`}
        alerts={alerts}
        hoverText={`Indicadores pendentes: \n` + (pendingRecords.length > 0 ? pendingRecords.join(',\n') : 'Nenhum indicador pendente')}
    />
}   